import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH, FONT } from "../../shared/styles";
import { EMAIL_HIERARCHY } from "./constants";

function BusinessEmailHierarchy({ hierarchy }) {
  const items =
    Array.isArray(hierarchy) && hierarchy.length > 0 ? hierarchy : EMAIL_HIERARCHY;

  return (
    <Box sx={{ mt: "32px", width: "100%", maxWidth: CONTENT_MAX_WIDTH }}>
      <Typography
        component="h3"
        sx={{
          m: 0,
          color: COLORS.textPrimary,
          fontFamily: FONT.family,
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "34px",
        }}
      >
        Email Hierarchy
      </Typography>

      <Box
        sx={{
          mt: "16px",
          width: "100%",
          minHeight: "280px",
          p: "16px",
          borderRadius: "8px",
          border: `1px solid ${COLORS.border}`,
          bgcolor: COLORS.backgroundLight,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {items.map((item, index) => {
            const title = item.title || item.label || item.name || `Level ${index + 1}`;
            const description =
              item.description ||
              item.detail ||
              (item.email ? item.email : "");
            const key = `${title}-${index}`;

            return (
              <Box key={key} sx={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    border: `1px solid ${COLORS.border}`,
                    bgcolor: "#F1F3F5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    color: COLORS.textPrimary,
                    fontFamily: FONT.family,
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: 1,
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    component="p"
                    sx={{
                      m: 0,
                      color: COLORS.textPrimary,
                      fontFamily: FONT.family,
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "22px",
                    }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    component="p"
                    sx={{
                      m: 0,
                      mt: "2px",
                      color: COLORS.textSecondary,
                      fontFamily: FONT.family,
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "18px",
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default BusinessEmailHierarchy;
